import CONSTANT from 'BASE/common/chat/chat.constant'
import { actionTypes, mutationTypes } from 'BASE/store/types'
import SETTING from 'BASE/common/chat/chat.setting'

export default {
    props: {
        dialog: Object
    },
    data: function () {
        return {
            inputMessage: "",
            errorMessages: [],
            maxContentSize: SETTING.MESSAGE_CONTENT_MAX_SIZE
        }
    },
    methods: {
        clear: function(){
            this.errorMessages = [];
            this.inputMessage = "";
        },
        getRoomIds: function(){
            let roomIds = [];
            this.$store.state.chat.rooms.forEach((item) => {
                if (item.type === CONSTANT.roomType.DESCENDANT) {
                    roomIds.push(item.id);
                }
            });
            return roomIds;
        },
        confirm: async function () {
            let loader = this.$loading.show();
            if (this.inputMessage === "") {
                this.errorMessages.push("请输入群发消息内容!");
                this.hideLoader(loader);
                return;
            }

            if (this.inputMessage.length > SETTING.MESSAGE_CONTENT_MAX_SIZE) {
                this.errorMessages.push(`群发内容最大长度${SETTING.MESSAGE_CONTENT_MAX_SIZE}`);
                this.hideLoader(loader);
                return;
            }

            let roomIds = this.getRoomIds();
            if (roomIds.length == 0) {
                this.errorMessages.push(`请选择下级人员`);
                this.hideLoader(loader);
                return;
            }

            //#35834 當下級很多個(>900), 因為isMulticasting變true會導致vue更新監聽的computed所需時間變長, 用setTimeout是為了讓$loading mask顯示
            let multiCastingTimeout = setTimeout(() => { this.$store.commit(mutationTypes.CHAT_SET_MULTICASTING, { isMulticasting: true }); }, 1000);

            this.$nextTick(async function () {
                let messages = await this.$store.dispatch(actionTypes.CHAT_SEND_MESSAGE_MULTICAST, {
                    roomIds: roomIds,
                    type: CONSTANT.messageType.TEXT,
                    content: this.inputMessage,
                });

                if (messages.length > 0) {
                    this.errorMessages = messages;
                } else {
                    this.clear();
                    this.dialog.$emit('close', { isSuccess: true });
                }
                
                clearTimeout(multiCastingTimeout);
                this.$store.commit(mutationTypes.CHAT_SET_MULTICASTING, { isMulticasting: false });
                this.hideLoader(loader);
            });
        },
        cancel: function () {
            this.clear();
            this.dialog.$emit('close', { isSuccess: false });
        },
        hideLoader: function (loader) {
            if (loader) {
                loader.hide();
            }
        }
    },
    computed: {
    },
};